(function () {
  'use strict';

  function pushDataLayer(detail) {
    if (!window.dataLayer) return;
    window.dataLayer.push({
      event: 'rr_friction_fix',
      rr_module: detail.module || '',
      rr_surface: detail.surface || '',
      rr_action: detail.action || '',
      rr_product_id: detail.productId || null,
      rr_review_count: detail.reviewCount || null,
      rr_rating_value: detail.ratingValue || null,
      rr_threshold_remaining_cents: detail.thresholdRemainingCents || null,
      rr_variant_id: detail.variantId || null
    });
  }

  function trackKlaviyo(detail) {
    var trackEvent = {
      eventName: 'Friction Fix Interaction',
      payload: {
        Module: detail.module || '',
        Surface: detail.surface || '',
        Action: detail.action || '',
        ProductID: detail.productId ? String(detail.productId) : null,
        VariantID: detail.variantId ? String(detail.variantId) : null,
        ReviewCount: detail.reviewCount || null,
        RatingValue: detail.ratingValue || null,
        ThresholdRemainingCents: detail.thresholdRemainingCents || null
      },
      dedupeKey: 'friction-fix:' +
        [detail.module || '', detail.surface || '', detail.action || '', detail.productId || '', detail.variantId || ''].join(':'),
      ttlMs: 500
    };

    if (!window.RRKlaviyo || typeof window.RRKlaviyo.track !== 'function') {
      window.__rrPendingKlaviyoEvents = window.__rrPendingKlaviyoEvents || [];
      window.__rrPendingKlaviyoEvents.push(trackEvent);
      return;
    }

    window.RRKlaviyo.track(trackEvent.eventName, trackEvent.payload, trackEvent.dedupeKey, trackEvent.ttlMs);
  }

  function sanitizeEventName(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '') || 'rr_friction_fix';
  }

  function trackClarity(detail) {
    if (typeof window.clarity !== 'function') return;

    try {
      window.clarity('set', 'rr_module', String(detail.module || ''));
      window.clarity('set', 'rr_surface', String(detail.surface || ''));
      window.clarity('set', 'rr_action', String(detail.action || ''));

      if (detail.productId) window.clarity('set', 'rr_product_id', String(detail.productId));
      if (detail.variantId) window.clarity('set', 'rr_variant_id', String(detail.variantId));

      window.clarity('event', sanitizeEventName(['rr', detail.module, detail.action].join('_')));
    } catch (error) {
    }
  }

  document.addEventListener('rr:friction-fix', function (event) {
    if (!event || !event.detail) return;
    pushDataLayer(event.detail);
    trackKlaviyo(event.detail);
    trackClarity(event.detail);
  });
})();
